module.exports = __webpack_public_path__ + "media/theme/sample-card__itunes-a6ae5216.jpg";